import React, { useState } from "react";

import russia from "../../../../../images/shared/flagCountry/russia.svg";
import uk from "../../../../../images/shared/flagCountry/uk.svg";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { changeLanguage } from "../../../../redux/actions/authorizationActions";

import styles from "../shared/Shared.module.scss";
export const TogleLang = () => {
  const lang = useSelector((state) => state.Reducer.language);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const handelRussian = (e) => {
    e.stopPropagation();
    dispatch(changeLanguage("ru"));
    setShow(false);
  };
  const handelEnglish = (e) => {
    e.stopPropagation();
    dispatch(changeLanguage("en"));
    setShow(false);
  };
  const handelShow = () => {
    setShow(true);
  };
  return (
    <>
      <div className={clsx(styles.wrapperTogleLangAll)} onClick={handelShow}>
        {show ? (
          <>
            <img src={russia} alt="Russia" onClick={handelRussian} />
            <img src={uk} alt="UK" onClick={handelEnglish} />
          </>
        ) : (
          <>
            {lang === "ru" ? (
              <>
                <img
                  src={russia}
                  alt="Russia"
                  onClick={(e) => handelRussian(e)}
                />
                <span>{lang.toUpperCase()}</span>
              </>
            ) : (
              <>
                <img src={uk} alt="UK" onClick={(e) => handelEnglish(e)} />
                <span>{lang.toUpperCase()}</span>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
